// removed by extract-text-webpack-plugin
module.exports = {"category-facilities":"src-modules-products-EditProductView-StepAccommodationSettings-__CategoryFacilitiesFormSection__category-facilities--29asv"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/products/EditProductView/StepAccommodationSettings/CategoryFacilitiesFormSection.less
// module id = 1890
// module chunks = 0